import { render, staticRenderFns } from "./LabelsImport.vue?vue&type=template&id=0056f764&"
import script from "./LabelsImport.vue?vue&type=script&lang=js&"
export * from "./LabelsImport.vue?vue&type=script&lang=js&"
import style0 from "./LabelsImport.vue?vue&type=style&index=0&id=0056f764&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports